<bc-tag
    *ngIf="refrescarBtnEstados" 
    [typeButtonTag]="'primary'" 
    [textElement]="dataFactura.estado.nombre"
    [values]="estadosList" 
    (valueOutput)="seleccionarEstado($event)" 
    [typeTag]="'dropdown'"
    [status]="isTagDisabled(dataFactura.estado.codigo)"
    componentId="btnEstados"
    #btnEstados>
</bc-tag>


<div>
    <bc-modal [title]="title" [displayButton]="false" [customWidth]="customWidth" titleAlign="center" #rechazado>
        <div modalContent class="bc-text-center">
            <form [formGroup]="formCausalesRechazo" autocomplete="off" (ngSubmit)="validarFormulario()">
                <div class="bc-row bc-mt-5">
                    <div class="bc-col-12">
                        <bc-input-select componentId="tipoCausalRechazo" [formatType]="'simple'"
                            [values]="causalesRechadoList" label="Seleccione la causal de rechazo"
                            formControlName="causalRechazo">
                        </bc-input-select>
                    </div>
                </div>
                <div class="bc-row bc-mt-5">
                    <div class="bc-col-12">
                        <button bc-button typeButton="primary" sizeButton="small">Asignar</button>
                    </div>
                </div>
            </form>
        </div>
    </bc-modal>
</div>

<div class="bc-row">
    <div class="bc-col-12">
        <app-modal [bandera]="isModal" [title]="titleModal" [typeIcon]="typeIconModal" customWidth="medium"
            [body]="bodyModal" [subBody]="subBodyModal"></app-modal>
    </div>
</div>


<div>
    <bc-modal typeIcon="info" customWidth="small" titleAlign="center" [isCancellable]="confirmAction"
        [subTitle]="confirmSubTitle" [buttonAlignment]="confirmButtonAlignment" textBtn="Sí" textBtnLeft="No"
        typeNotify="success" [displayButton]="confirmDisplayButton" [outerCloseTap]="confirmOuterCloseTap"
        (stateClick)="onPressButton($event)" #confirmacion>
        <div modalContent>
            <div class="bc-row">
                <div class="bc-col-5">
                    Factura
                </div>
                <div class="bc-col-7">
                    <span class="bc-cibsans-font-style-3-bold">{{ dataFactura.numero_factura }}</span>
                </div>
            </div>
            <div class="bc-row">
                <div class="bc-col-5">
                    Estado Anterior
                </div>
                <div class="bc-col-7">
                    <span class="bc-text-brand-complementary-01">{{ dataFactura.estado.codigo }}</span>
                </div>
            </div>
            <div class="bc-row">
                <div class="bc-col-5">
                    Nuevo Estado
                </div>
                <div class="bc-col-7">
                    <span class="bc-text-brand-complementary-00">{{ nuevoEstadoConfirm.value }}</span>
                </div>
            </div>
        </div>
    </bc-modal>
</div>